/* Component Dependencies */
var heroImageHeaderTextCtaTemplate = require('templates/heroImageHeaderTextCta.hbs');
var AriesComponent = require('libs/aries-component');

AriesComponent.create({
  type: 'heroImageHeaderTextCta',
  template: {
    'heroImageHeaderTextCta': heroImageHeaderTextCtaTemplate
  }
});
